import { render, staticRenderFns } from "./SmallMove.vue?vue&type=template&id=07c6c9a0&"
import script from "./SmallMove.vue?vue&type=script&lang=js&"
export * from "./SmallMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports